module.exports = __webpack_public_path__ + "img/detallecurso2.d62e9368.png";